const ORDER_TYPE = {
	NEW: {
		code: 1,
		label: "common.typeList.orderType.new"
	},
	ORDERED: {
		code: 2,
		label: "common.typeList.orderType.ordered"
	},
	CANCELLED: {
		code: 3,
		label: "common.typeList.orderType.cancelled"
	}
}

export default ORDER_TYPE
